import { memo } from 'react';
import { useDragLayer } from 'react-dnd';
import { usePreview } from 'react-dnd-preview';
// Import components
import SegmentItemView from './SegmentItemView';

const layerStyles: React.CSSProperties = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};

interface Props {
    getRowByIndex: (index: number) => { data: AnyObject };
}

const SegmentItemPreview: React.FC<Props> = ({ getRowByIndex }) => {
    const previewCollect = usePreview<AnyObject>();
    const collect = useDragLayer((monitor) => {
        return {
            item: monitor.getItem(),
            itemType: monitor.getItemType(),
            initialOffset: monitor.getInitialSourceClientOffset(),
            currentOffset: monitor.getClientOffset(),
            isDragging: monitor.isDragging(),
        };
    });

    if (!previewCollect.display) {
        return null;
    }
    if (!collect.isDragging) {
        return null;
    }

    const getItemStyles = (initialOffset, currentOffset, defaultTranslateX = 50, defaultTranslateY = 40) => {
        if (!initialOffset || !currentOffset) {
            return {
                display: 'none',
            };
        }
        const { x, y } = currentOffset;
        const transform = `translate(${x - defaultTranslateX}px, ${y - defaultTranslateY}px)`;

        return {
            transform,
            WebkitTransform: transform,
            maxWidth: '498px',
        };
    };
    const { data } = getRowByIndex(previewCollect?.item?.index) || {};

    const { Type, Name } = data || {};

    return (
        <div style={layerStyles}>
            <div
                className="dropping-container-info-inner"
                style={getItemStyles(collect.initialOffset, collect.currentOffset)}
            >
                <SegmentItemView type={Type} title={Name} />
            </div>
        </div>
    );
};

export default memo(SegmentItemPreview);
